
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

const StoreSettings = () => {
  return (
    <Tabs defaultValue="general" className="space-y-4">
      <TabsList>
        <TabsTrigger value="general">General</TabsTrigger>
        <TabsTrigger value="shipping">Shipping</TabsTrigger>
        <TabsTrigger value="checkout">Checkout</TabsTrigger>
        <TabsTrigger value="notifications">Notifications</TabsTrigger>
      </TabsList>
      
      <TabsContent value="general" className="space-y-4">
        <Card>
          <CardHeader>
            <CardTitle>Store Details</CardTitle>
            <CardDescription>Configure your merchandise store basic information</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label htmlFor="store-name">Store Name</Label>
                <Input id="store-name" defaultValue="My Artist Merch Store" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="store-url">Custom Domain (optional)</Label>
                <Input id="store-url" placeholder="merch.yourartistname.com" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="store-currency">Default Currency</Label>
                <Select defaultValue="USD">
                  <SelectTrigger id="store-currency">
                    <SelectValue placeholder="Select Currency" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="USD">US Dollar (USD)</SelectItem>
                    <SelectItem value="EUR">Euro (EUR)</SelectItem>
                    <SelectItem value="GBP">British Pound (GBP)</SelectItem>
                    <SelectItem value="CAD">Canadian Dollar (CAD)</SelectItem>
                    <SelectItem value="AUD">Australian Dollar (AUD)</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div className="space-y-2">
                <Label htmlFor="tax-included">Tax Settings</Label>
                <div className="flex items-center space-x-2 pt-2">
                  <Checkbox id="tax-included" />
                  <label 
                    htmlFor="tax-included" 
                    className="text-sm font-medium leading-none cursor-pointer"
                  >
                    Show prices with tax included
                  </label>
                </div>
              </div>
            </div>
            <div className="pt-4">
              <Button>Save Store Settings</Button>
            </div>
          </CardContent>
        </Card>
      </TabsContent>
      
      <TabsContent value="shipping" className="space-y-4">
        <Card>
          <CardHeader>
            <CardTitle>Shipping Options</CardTitle>
            <CardDescription>Configure shipping methods and delivery zones</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground mb-4">
              Shipping settings are managed through your connected platform (Shopify, WooCommerce).
              For customized shipping options, please visit your platform's admin dashboard.
            </p>
            <Button variant="outline">
              Open Platform Shipping Settings
            </Button>
          </CardContent>
        </Card>
      </TabsContent>
      
      <TabsContent value="checkout" className="space-y-4">
        <Card>
          <CardHeader>
            <CardTitle>Checkout Settings</CardTitle>
            <CardDescription>Configure checkout experience and payment options</CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground mb-4">
              Checkout and payment settings are managed through your connected platform.
              For customized checkout options, please visit your platform's admin dashboard.
            </p>
            <Button variant="outline">
              Open Platform Checkout Settings
            </Button>
          </CardContent>
        </Card>
      </TabsContent>
      
      <TabsContent value="notifications" className="space-y-4">
        <Card>
          <CardHeader>
            <CardTitle>Notification Settings</CardTitle>
            <CardDescription>Configure order and inventory notifications</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <Checkbox id="notify-orders" defaultChecked />
                <label 
                  htmlFor="notify-orders" 
                  className="text-sm font-medium leading-none cursor-pointer"
                >
                  Receive notifications for new orders
                </label>
              </div>
              <div className="flex items-center space-x-2">
                <Checkbox id="notify-inventory" defaultChecked />
                <label 
                  htmlFor="notify-inventory" 
                  className="text-sm font-medium leading-none cursor-pointer"
                >
                  Receive notifications for low inventory
                </label>
              </div>
              <div className="flex items-center space-x-2">
                <Checkbox id="notify-returns" />
                <label 
                  htmlFor="notify-returns" 
                  className="text-sm font-medium leading-none cursor-pointer"
                >
                  Receive notifications for returns/refunds
                </label>
              </div>
            </div>
            <div className="pt-4">
              <Button>Save Notification Settings</Button>
            </div>
          </CardContent>
        </Card>
      </TabsContent>
    </Tabs>
  );
};

export default StoreSettings;
